import type { TelemetryProvider, TelemetryRuntime } from "../../core/types.js";
import type { ProviderConfig } from "../../schema/provider.js";
import type { ProviderCreateContext } from "../plugin-context.js";

export type ProviderPluginCreator = (
  config: ProviderConfig,
  runtime: TelemetryRuntime,
  ctx: ProviderCreateContext,
) => TelemetryProvider;

const plugins = new Map<ProviderConfig["type"], ProviderPluginCreator>();

export function registerProviderPlugin(
  type: ProviderConfig["type"],
  create: ProviderPluginCreator,
): void {
  plugins.set(type, create);
}

export function createProviderFromPlugin(
  config: ProviderConfig,
  runtime: TelemetryRuntime,
  ctx: ProviderCreateContext,
): TelemetryProvider {
  const create = plugins.get(config.type);
  if (!create) {
    throw new Error(
      `[telemetry] No provider plugin registered for type "${config.type}". Import the provider subpath (e.g. @komerce/telemetry/providers/sentry/client or /server) when using createTelemetry with Sentry().`,
    );
  }
  return create(config, runtime, ctx);
}
